import React from 'react';
import { NavLink } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { ROLES } from '../../utils/constants';
import './Sidebar.css';

export default function Sidebar() {
  const { user } = useAuth();

  const menuItems = {
    [ROLES.AGENT]: [
      { path: '/dashboard', label: 'Dashboard', icon: '📊' },
      { path: '/my-tickets', label: 'My Tickets', icon: '🎫' },
      { path: '/profile', label: 'Profile', icon: '👤' },
    ],
    [ROLES.TEAM_LEAD]: [
      { path: '/dashboard', label: 'Dashboard', icon: '📊' },
      { path: '/my-tickets', label: 'My Tickets', icon: '🎫' },
      { path: '/team-tickets', label: 'Team Tickets', icon: '👥' },
      { path: '/team-performance', label: 'Team Performance', icon: '📈' },
      { path: '/profile', label: 'Profile', icon: '👤' },
    ],
    [ROLES.MANAGER]: [
      { path: '/dashboard', label: 'Dashboard', icon: '📊' },
      { path: '/all-tickets', label: 'All Tickets', icon: '🎫' },
      { path: '/manage-agents', label: 'Manage Agents', icon: '👥' },

      { path: '/analytics', label: 'Analytics', icon: '📈' }, 
      { path: '/profile', label: 'Profile', icon: '👤' },
    ],
  };

  const currentMenu = menuItems[user?.role] || menuItems[ROLES.AGENT];

  return (
    <aside className="sidebar">
      <div className="sidebar-header">
        <h1>🎯 Support</h1>
        <p className="role-badge">{user?.role?.replace('_', ' ')}</p>
      </div>

      <nav className="sidebar-nav">
        {currentMenu.map((item) => (
          <NavLink
            key={item.path}
            to={item.path}
            className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
          >
            <span className="nav-icon">{item.icon}</span>
            <span className="nav-label">{item.label}</span>
          </NavLink>
        ))}
      </nav>

      <div className="sidebar-footer">
        <p>© 2025 Support Panel</p>
      </div>
    </aside>
  );
}
